.earlier {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
}

.heading {
  font-size: 17px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 44px;
  padding: 0 12px;
  border: 1.5px solid var(--ink);
  border-radius: var(--radius-control);
  color: var(--ink);
  text-decoration: none;
}

.when {
  font-weight: 700;
}

.state {
  font-size: 13px;
  color: var(--ink-2);
}

.hint {
  font-size: 13px;
  color: var(--ink-3);
}
